import applyMetrics from './metrics';
import normalize from './normalize';

export default function derivePerson({
  activity,
  deriveMetrics,
  metrics,
  peopleSet,
  personId,
  roleId,
  roleSet,
  snapshot,
}) {
  const role = snapshot.entities.roles[roleId] ?? null;
  const group = snapshot.entities.groups[role?.group_uuid] ?? null;
  const id = personId || role?.person_uuid;

  if (!id) {
    return;
  }

  const isNewPerson = peopleSet?.has(id) ?? false;
  const person = isNewPerson
    ? normalize({
        person: snapshot.entities.people[id],
        peopleSet,
        role,
        snapshot,
      })
    : snapshot.entities.people[id];

  if (deriveMetrics && person?.__metrics) {
    person.__metrics.self = applyMetrics({
      activity,
      peopleSet,
      person,
      role,
      roleSet,
      group,
      metrics,
    });
  }

  return person;
}
